<template>
	<v-layout
		row
		wrap
		align-center
		justify-center
		class="mb-2"
	>
		<v-flex>
			<v-toolbar class="iterator-toolbar">
				<v-flex
					sm6
					hidden-xs-only
				>
					<v-text-field
						v-model="searchData"
						append-icon="search"
						label="Search"
						single-line
						hide-details
						class="pa-0"
					/>
				</v-flex>
				<v-flex
					v-if="this.$vuetify.breakpoint.xs"
					slot="extension"
				>
					<v-text-field
						v-model="searchData"
						append-icon="search"
						label="Search"
						single-line
						hide-details
					/>
				</v-flex>
				<v-spacer/>
				<slot name="additional"/>
				<span
					v-if="!hideSort"
					class="hidden-xs-only"
				>
					Sort:
				</span>
				<v-menu
					v-if="!hideSort"
					open-on-hover
					bottom
				>
					<v-btn
						slot="activator"
						flat
					>
						{{ sortName }}
					</v-btn>
					<v-list>
						<v-list-tile
							v-for="(option, index) in sortBy"
							:key="index"
							@click="sort(option)"
						>
							<v-list-tile-title>{{ option.name }}</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
				<v-divider
					vertical
				/>
				<v-btn
					flat
					icon
					@click.native="changeSortDirection"
				>
					<v-icon v-if="pagination.descending">arrow_downward</v-icon>
					<v-icon v-else>arrow_upward</v-icon>
				</v-btn>
				<v-divider
					vertical
				/>
				<v-btn-toggle
					v-if="!hideChangeView"
					v-model="changeView"
					class="transparent px-3"
					mandatory
				>
					<v-btn flat>
						<v-icon>view_module</v-icon>
					</v-btn>
					<v-btn flat>
						<v-icon>view_list</v-icon>
					</v-btn>
				</v-btn-toggle>
			</v-toolbar>
		</v-flex>
		<transition name="scale-transition">
			<v-flex
				v-show="extended"
				md10
				mb-2
			>
				<v-card>
					<v-container py-0>
						<v-layout
							row
							wrap
							justify-space-around
							align-center
							class="px-2"
						>
							<slot name="extended"/>
						</v-layout>
					</v-container>
				</v-card>
			</v-flex>
		</transition>
	</v-layout>
</template>

<script>
export default {
	props: {
		sortBy: { type: Array, default: () => [] },
		sortName: { type: String, default: '' },
		pagination: { type: Object, default: () => {} },
		extended: { type: Boolean, default: false },
		initialView: { type: Number, default: 0 },
		hideSort: { type: Boolean, default: false },
		hideChangeView: { type: Boolean, default: false },
	},
	data() {
		return {
			changeView: 0,
			searchData: '',
		};
	},
	watch: {
		changeView(val) {
			this.$emit('change-view', val);
		},
		searchData(val) {
			this.$emit('search', val);
		},
	},
	created() {
		this.changeView = this.initialView;
	},
	methods: {
		sort(option) {
			this.$emit('sort', option);
		},
		changeSortDirection() {
			this.$emit('pagination');
		},
	},
};
</script>

<style lang="scss">
.iterator-toolbar {
	.v-toolbar__content {
		padding-right: 0;
	}
}
</style>
